import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.label`
  color: ${colors.DARK};
  font-size: 12px;
  font-weight: normal;
`;

export const InputWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
`;

export const Input = styled.input`
  /* Visually hidden but FOCUSABLE (display:none removed a keyboard user's
     only way to toggle the field) — sized over the track so pointer hits
     land on the real control, with a visible focus ring on the Indicator. */
  position: absolute;
  opacity: 0;
  width: 40px;
  height: 20px;
  margin: 0;
  cursor: pointer;
  z-index: 1;

  &:focus-visible + div {
    outline: 2px solid ${colors.MAIN_COLOR};
    outline-offset: 2px;
  }
`;

export const Indicator = styled.div`
  position: absolute;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.LIGHT_GRAY};
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 20px;
  margin: 0;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 0;
    bottom: 0px;
    background-color: ${colors.WHITE};
    border: 1px solid ${colors.LIGHT_GRAY};
    border-radius: 50%;
  }

  ${({ value, disabled, disabledValue }) =>
    (disabled ? disabledValue : value) && `
      background-color: ${colors.GREEN};
      border: 1px solid ${colors.GREEN};

      &:before {
        height: 18px;
        width: 18px;
        left: 20px;
        top: 0px;
        border: 1px solid ${colors.GREEN};
      }
    `
  }
`;
